module.exports = __webpack_public_path__ + "img/tete_AA02.168cfd18.jpg";